import { Grid, Card, CardHeader, CardContent, Divider, Box, Stack } from '@mui/material'
import ResultIcon from 'icons/ResultIcon'
import React from 'react'
import globalStyles from 'styles/globalStyles'
import CustomText from '../CustomText/CustomText'
import useGlobalStyles from 'styles/globalStyles'
import { colors } from 'styles/colors'
import Calculator from 'assets/new/calculator.png'
import useStyles from './styles'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';

interface Props {
  calculatedCPTs: any;
}

export default function RVUsResultSection({ calculatedCPTs }: Props) {
  const globalStyles = useGlobalStyles();
  const styles = useStyles();

  const totalRVUs = calculatedCPTs.reduce(
    (sum: number, cpt: any) => sum + cpt.totalRVUs,
    0
  )

  // Same rule as case procedure reimbursement: highest-RVU code gets full
  // value, the rest are discounted 50%.
  let maxIndex = -1
  let maxRvu = 0
  calculatedCPTs.forEach((cpt: any, index: number) => {
    if (cpt.totalRVUs > maxRvu) {
      maxRvu = cpt.totalRVUs
      maxIndex = index
    }
  })

  const reimbursableByRow = calculatedCPTs.map((cpt: any, index: number) =>
    index === maxIndex ? cpt.totalRVUs : cpt.totalRVUs * 0.5
  )
  const totalReimbursable = reimbursableByRow.reduce(
    (sum: number, value: number) => sum + value,
    0
  )


  return (
    <Grid size={{ xs: 12, md: 6 }}>
      <Card className={styles.card}>
        <CardHeader
          avatar={<ResultIcon size={23} color='white' />}
          title="Result"
          className={globalStyles.sectionPrimaryHeader}
          slotProps={{
            title: {
              className: globalStyles.sectionPrimaryHeaderTitle,
            },
          }}
        />

        <CardContent className={styles.cardContent}>
          {calculatedCPTs.length > 0 ? (
            <>
              {/* Header */}
              <Grid container mb={2}>
                <Grid size={{ xs: 4 }}>
                  <CustomText
                    text="RVU Value per Unit"
                    fontSize={15}
                    fontWeight={600}
                    color={colors.black}
                  />
                </Grid>
                <Grid size={{ xs: 4 }}>
                  <CustomText
                    text="Total RVUs"
                    fontSize={15}
                    fontWeight={600}
                    color={colors.black}
                  />
                </Grid>
                <Grid size={{ xs: 4 }}>
                  <CustomText
                    text="Reimbursable"
                    fontSize={15}
                    fontWeight={600}
                    color={colors.black}
                  />
                </Grid>
              </Grid>

              <Divider />

              {/* Rows */}
              {calculatedCPTs.map((cpt: any, index: number) => (
                <Grid
                  container
                  key={index}
                  py={1}
                  borderBottom="1px solid #eee"
                  sx={{ display: 'flex' }}
                >
                  <Grid size={{ xs: 4 }}>
                    <CustomText
                      text={cpt.rvuPerUnit.toFixed(2)}
                      fontSize={15}
                      color={colors.black}
                    />
                  </Grid>

                  <Grid size={{ xs: 4 }}>
                    <CustomText
                      text={cpt.totalRVUs.toFixed(2)}
                      fontSize={15}
                      color={colors.black}
                    />
                  </Grid>

                  <Grid size={{ xs: 4 }}>
                    <CustomText
                      text={`${reimbursableByRow[index].toFixed(2)}${index === maxIndex ? '' : ' (50%)'}`}
                      fontSize={15}
                      color={colors.black}
                    />
                  </Grid>
                </Grid>
              ))}
              <Box sx={{ flexGrow: 1 }} />

            </>
          ) : (
            <Box
              sx={{
                flexGrow: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
              }}
            >
              <Box
                component="img"
                src={Calculator}
                alt="Calculator"
                sx={{
                  width: { xs: 160, md: 200, lg: 260 },
                  maxWidth: '50%',
                  height: 'auto',
                  my: 5,
                  opacity: 0.8,
                }}
              />
              <CustomText
                text="Start calculating to get the result!"
                fontSize={18}
                color={colors.secondary}
                my={2}
              />
            </Box>

          )}

        </CardContent>

        {/* TOTAL — pinned to bottom */}

        <Divider />

        {totalRVUs > 0 && <>
          <Grid container sx={{
            display: 'flex',
            alignItems: 'center',
            height: 50,
            p: 1.5,
          }}>
            <Grid size={{ xs: 6 }}>
              <Stack direction={'row'} alignItems={'center'} spacing={1}>
                <FormatListBulletedIcon sx={{fontSize: 20}}/>
                <CustomText
                  text="Total Reimbursable"
                  fontSize={16}
                  fontWeight={600}
                  color={colors.black}
                />
              </Stack>
            </Grid>
            <Grid size={{ xs: 6 }} textAlign={'right'}>
              <CustomText
                text={totalReimbursable.toFixed(2)}
                fontSize={16}
                fontWeight={600}
                color={colors.black}
              />
            </Grid>
          </Grid>
        </>}

      </Card>



    </Grid>
  )
}
